import React from 'react'
import { TooltipRenderProps } from 'react-joyride'
import { ChevronLeft, ChevronRight } from 'lucide-react'
import { motion } from 'framer-motion'
import styles from './TutorialSpotlight.module.scss'

const CustomTooltip: React.FC<TooltipRenderProps> = ({
  continuous,
  index,
  isLastStep,
  size,
  step,
  backProps,
  closeProps,
  primaryProps,
  skipProps,
  tooltipProps,
}) => {
  const progress = ((index + 1) / size) * 100
  const isFirstStep = index === 0

  return (
    <div {...tooltipProps} className={styles.tooltip}>
      <div className={styles.tooltipContent}>
        {step.title && (
          <h3 className={styles.tooltipTitle}>{step.title}</h3>
        )}
        {step.content && (
          <p className={styles.tooltipDescription}>{step.content}</p>
        )}
      </div>

      <div className={styles.tooltipFooter}>
        <div className={styles.progressBar}>
          <motion.div
            className={styles.progressFill}
            initial={false}
            animate={{ width: `${progress}%` }}
            transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
          />
        </div>
        <div className={styles.progressText}>
          {index + 1} de {size}
        </div>
      </div>

      <div className={styles.tooltipActions}>
        <button
          {...skipProps}
          className={styles.skipButton}
        >
          Saltar tutorial
        </button>
        <div className={styles.navigationButtons}>
          {!isFirstStep && (
            <button
              {...backProps}
              className={styles.navButton}
              aria-label="Paso anterior"
            >
              <ChevronLeft size={20} />
            </button>
          )}
          {continuous && (
            <button
              {...primaryProps}
              className={`${styles.navButton} ${styles.primaryButton} ${isLastStep ? styles.finishButton : ''}`}
              aria-label={isLastStep ? 'Finalizar' : 'Siguiente paso'}
            >
              {isLastStep ? 'Finalizar' : <ChevronRight size={20} />}
            </button>
          )}
        </div>
      </div>
    </div>
  )
}

export default CustomTooltip

